import { LayoutProps } from '~/types/layout'

const PrintLayout = ({ children }: LayoutProps) => {
  return <main className="flex h-full w-full justify-center md:items-center">{children}</main>
}

export default PrintLayout
